import { render, staticRenderFns } from "./oldRecordWhitelistMain.vue?vue&type=template&id=1da4b0e8&scoped=true&"
import script from "./oldRecordWhitelistMain.vue?vue&type=script&lang=js&"
export * from "./oldRecordWhitelistMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da4b0e8",
  null
  
)

export default component.exports